import dayjs from "dayjs";
import styles from "./InvoiceInformation.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

export interface IInvoiceInformation {
  number: string;
  total: string;
  paid: string;
  remaining: string;
  page: string;
  invoiceDate: string;
  dueDate: string;
  related: string;
  status: string;
  signed: string;
  isArchived: string;
  createdBy: string;
  createdAt: string;
}

interface IInvoiceInformationProps {
  invoiceInformation: IInvoiceInformation | null;
}

const InvoiceInformation = ({ invoiceInformation }: IInvoiceInformationProps) => {
  const invoiceInfoData = [
    { label: "Number", value: invoiceInformation?.number || "-" },
    { label: "Total", value: `$${invoiceInformation?.total || "-"}` },
    { label: "Paid", value: `$${invoiceInformation?.paid || "-"}` },
    { label: "Remaining", value: `$${invoiceInformation?.remaining || "-"}` },
    { label: "Page", value: invoiceInformation?.page || "-" },
  ];

  const workflowData = [
    { label: "Invoice Date", value: `${dayjs(invoiceInformation?.invoiceDate).format("MM/DD/YYYY")}` || "-" },
    { label: "Due Date", value: `${dayjs(invoiceInformation?.dueDate).format("MM/DD/YYYY")}` || "-"  },
    { label: "Related", value: invoiceInformation?.related || "-" },
    { label: "Status", value: invoiceInformation?.status || "-" },
    { label: "Signed", value: invoiceInformation?.signed || "-" },
    { label: "Is Archived?", value: invoiceInformation?.isArchived || "-" },
  ];

  const statusClass = workflowData[3].value?.toLowerCase() || "";

  return (
    <div className={cx("invoice-information-container")}>
      <div className={cx("content")}>
        <div className={cx("content-header")}>
          <h3 className={cx("content-header-title")}>Invoice Information</h3>
        </div>

        <div className={cx("content-body")}>
          {invoiceInfoData.map((item) => (
            <div className={cx("row")}>
              <div className={cx("label")}>{item.label}</div>
              <div className={cx("divider")}>:</div>
              <div className={cx("value")}>{item.value}</div>
            </div>
          ))}
        </div>
      </div>
      <div className={cx("content")}>
        <div className={cx("content-header")}>
          <h3 className={cx("content-header-title")}>Workflow</h3>
        </div>

        <div className={cx("content-body")}>
          {workflowData.map((item) => (
            <div className={cx("row")}>
              <div className={cx("label")}>{item.label}</div>
              <div className={cx("divider")}>:</div>
              <div className={cx("value")}>
                <p
                  className={cx(
                    "value-text",
                    { "value-link": item.label === "Related" },
                    { [statusClass]: item.label === "Status" }
                  )}
                >
                  {item.value}
                </p>
              </div>
            </div>
          ))}

          <div className={cx("create-by-container")}>
            Created By <span className={cx("create-by-value")}>{invoiceInformation?.createdBy || "-"}</span> on {`${dayjs(invoiceInformation?.createdAt).format("MM/DD/YYYY hh:mm A")}`}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceInformation;
